import TokenAnalyzerMenu from "./TokenAnalyzerMenu";

export default TokenAnalyzerMenu;